export const COLLECTION_LAYOUT_LIST = [
    {
        id: 'list',
        ariaLabel: 'List',
        className: 'icon-mode-list',
        type: 'list',
        gridSize: 1,
    },
    {
        id: 'grid2',
        ariaLabel: 'Grid 2',
        className: 'icon-mode-grid grid-2',
        type: 'grid',
        gridSize: 2,
    },
    {
        id: 'grid3',
        ariaLabel: 'Grid 3',
        className: 'icon-mode-grid grid-3',
        type: 'grid',
        gridSize: 3,
    },
    {
        id: 'grid4',
        ariaLabel: 'Grid 4',
        className: 'icon-mode-grid grid-4',
        type: 'grid',
        gridSize: 4,
    },
    {
        id: 'grid5',
        ariaLabel: 'Grid 5',
        className: 'icon-mode-grid grid-5',
        type: 'grid',
        gridSize: 5,
    },
];
